import { Formik, FormikHelpers } from 'formik';
import React, { FunctionComponent, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastError, ToastSuccess } from 'utils/toast';
import { TradeCreate } from './trade-form-create-repository';
import { tradeFormValidationSchema } from './trade-form-validation-schema';
import TradeFormView from './trade-form-view';

type TradesFormCreateContainerProps = {
  createTrade: (trade: TradeCreate) => Promise<unknown>;
};

type TradeFormCreateFields = {
  name: string;
  slug: string;
  pageTitle: string;
  anchor: string;
  pageTitleVariant: string;
  pageSubtitle: string;
  pageTitleDirectory: string;
  label: string;
  isChild: boolean;
  tradeGroups: number[];
  tradeKeywords: number[];
  metaTitle: string;
  metaDescription: string;
  isCallRecordable: boolean;
  isAnonymised: boolean;
  isRgeFilterable: boolean;
  schemaType: string;
  schemaAdditionalType: string;
};

const TradesFormCreateContainer: FunctionComponent<
  TradesFormCreateContainerProps
> = ({ createTrade }) => {
  const navigate = useNavigate();

  const initialFormValues: TradeFormCreateFields = useMemo(() => {
    return {
      name: '',
      slug: '',
      pageTitle: '',
      anchor: '',
      pageTitleVariant: '',
      pageSubtitle: '',
      pageTitleDirectory: '',
      label: '',
      isChild: false,
      metaTitle: '',
      metaDescription: '',
      tradeGroups: [],
      tradeKeywords: [],
      isCallRecordable: true,
      isAnonymised: false,
      isRgeFilterable: true,
      schemaType: '',
      schemaAdditionalType: '',
    };
  }, []);

  const handleSubmit = async (
    values: TradeFormCreateFields,
    actions: FormikHelpers<TradeFormCreateFields>,
  ): Promise<void> => {
    try {
      await createTrade(values);

      ToastSuccess('Succès', 'Catégorie enregistrée');
      actions.setSubmitting(false);
      navigate('/trades');
    } catch (error) {
      ToastError('Erreur', "Impossible d'enregistrer la catégorie");
    }
  };

  return (
    <Formik
      validateOnChange={false}
      validationSchema={tradeFormValidationSchema()}
      initialValues={initialFormValues}
      onSubmit={(value, actions): Promise<void> => {
        return handleSubmit(value, actions);
      }}
    >
      <TradeFormView />
    </Formik>
  );
};

export default TradesFormCreateContainer;
